export default async function init() {
  const element = document.querySelector('.event-list');

  if (element) {
    const { default: EventsList } = await import(/* webpackChunkName: "event-list" */ './event-list');

    new EventsList(element);
  }
}
